import React, { useState } from 'react'
import { AddFoodListPeriodComponent } from '../Components/FoodListPeriod/AddFoodListPeriodComponent';
import { AllFoodListPeriodComponent } from '../Components/FoodListPeriod/AllFoodListPeriodComponent';
import { EditFoodListPeriodComponent } from '../Components/FoodListPeriod/EditFoodListPeriodComponent';
import { FoodMealWeekComponent } from '../Components/FoodMeal/FoodMealWeekComponent';
import { FoodPeriodCategoryComponent } from '../Components/Category/FoodPeriodCategoryComponent';
// ======================================================================
export const FoodListPeriod = ({ setLoading, showMessage }) => {
    // ======================================================================
    const [view, setView] = useState('Category');
    const [categoryId, setCategoryId] = useState();
    const [categoryTitle, setCategoryTitle] = useState();

    const [currentPage, setCurrentPage] = useState(1);
    const [version, setVersion] = useState(0);
    const [id, setId] = useState(0);
    // ======================================================================
    return (
        <>
            {view === "Category" ?
                <FoodPeriodCategoryComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    onClickItems={(id, title) => {
                        setCategoryId(id);
                        setCategoryTitle(title);
                        setView("All");
                    }}
                />
                : <></>
            }
            {
                view == "All" ?
                    <AllFoodListPeriodComponent
                        setLoading={setLoading}
                        showMessage={showMessage}
                        categoryId={categoryId}
                        categoryTitle={categoryTitle}
                        version={version}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        onAddClick={() => setView("Add")}
                        onEdit={(id) => { setId(id); setView("Edit") }}
                        onRowDeleted={() => { setVersion(version + 1); }}
                        onFoodListWeekClick={(id) => { setId(id); setView("FoodMealWeek") }}
                        onBackClick={()=> setView("Category")}

                    /> : <></>
            }
            {
                view === "Add" ?
                    <AddFoodListPeriodComponent
                        setLoading={setLoading}
                        showMessage={showMessage}
                        categoryId={categoryId}
                        categoryTitle={categoryTitle}
                        rowInserted={() => {
                            setView("All"); if (currentPage != 1)
                                setCurrentPage(1);
                            else
                                setVersion(version + 1);
                        }}
                        cancelInsert={() => { setView("All"); }} />
                    : <></>
            }
            {
                view === "Edit" ?
                    <EditFoodListPeriodComponent
                        setLoading={setLoading}
                        showMessage={showMessage}
                        id={id}
                        rowUpdated={() => { setView("All"); setVersion(version + 1); }}
                        cancelEdit={() => { setView("All"); }} />
                    :
                    <></>
            }

            {
                view === "FoodMealWeek" ?
                    <>
                        <FoodMealWeekComponent
                            setLoading={setLoading}
                            showMessage={showMessage}
                            foodListPeriodId={id}
                            onBackClick={()=>{ setView("All"); setVersion(version + 1); }}
                        />
                    </>
                    :
                    <></>
            }
        </>
    )
}
